// ADC-IMPLEMENTS: <adc-006a-feature-context-01>
import { createContext, useContext } from 'react';
import { useAllIncidents, type UseAllIncidentsReturn } from '@/hooks/useAllIncidents';

const IncidentCtx = createContext<UseAllIncidentsReturn | null>(null);

export function IncidentProvider({ children }: { children: React.ReactNode }) {
  const value = useAllIncidents();
  return (
    <IncidentCtx.Provider value={value}>
      {children}
    </IncidentCtx.Provider>
  );
}

export function useIncidentContext(): UseAllIncidentsReturn {
  const ctx = useContext(IncidentCtx);
  if (!ctx) throw new Error('useIncidentContext must be used within IncidentProvider');
  return ctx;
}
